import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';
import { getManualInventoryChange, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getProductCategories, resetProductCategories } from 'actions/EntityActions';
import Pagination from 'screens/components/basic/Pagination';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import { reportManualInventoryChangeReport } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class ManualInventoryChange extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `ManualInventoryChangeBeginDate`);
        this.props.formInput(date, `ManualInventoryChangeEndDate`);
        this.props.getProductCategories(this.props.branchId || parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')));
    }

    componentWillUnmount() {
        this.props.resetProductCategories();
    }


    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = Array.isArray(this.props.branchIds) ? this.props.branchIds.join(",") : this.props.loggedBranch;
        let category = this.props.categoryFilter || 0;
        let filterAction = this.props.filterAction;
        let filterReason = this.props.filterReason;
        let isCannabis = this.props.isCannabis;
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/manualinventorychange?beginDate=${beginDate}&endDate=${endDate}&filterAction=${filterAction}&filterReason=${filterReason}&branch=${branch}&isCannabis=${isCannabis}&category=${category}`, "ManualInventoryChange");
        }
    }



    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getCategoryOptions = () => {
        return (this.props.category.list || []).map(item => {
            return {
                text: item.name,
                value: item.id.toString(),
                isCannabis: item.isCannabis
            };
        });
    }


    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = Array.isArray(this.props.branchIds) ? this.props.branchIds.join(",") : this.props.loggedBranch; // Allow multiple branches
        let pageNumber = this.state.activePage;
        let category = this.props.categoryFilter || 0;
        let pageSize = this.state.itemsPerPage;
        let filterAction = this.props.filterAction;
        let filterReason = this.props.filterReason;
        let isCannabis = this.props.isCannabis;
        this.props.getManualInventoryChange({ beginDate, endDate, pageNumber, pageSize, filterAction, filterReason, branch, category, isCannabis });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        const totalRow = this.props.manualInventoryChange.length > 0 ? this.props.manualInventoryChange[0].totalRows : 0;

        return (
            <Grid headerContent={reportManualInventoryChangeReport}>
                <PageHeader title={LOOKUP.report.manualInventoryChange.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-manual-inventory-change-report" />}
                    description={LOOKUP.report.manualInventoryChange.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    productCategories={this.getCategoryOptions()}
                    isCannabisOptions={this.props.isCannabisOptions}
                    isCannabis={this.props.isCannabis}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                    actionOptions={this.props.actionOptions}
                    reasonOptions={this.props.reasonOptions}
                />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody && this.props.manualInventoryChange &&
                    <CardSimple>
                        <Body
                            manualInventoryChange={this.props.manualInventoryChange}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            loggedBranch={this.props.loggedBranch}
                            branchForm={this.props.branchIds}
                        />
                        <Pagination
                            length={totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid >
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    let branchIds = state.form.ManualInventoryChangeBranchIds && state.form.ManualInventoryChangeBranchIds.length === 0
        ? branches.map(branch => branch.id) // Get all branch IDs if 'all' is selected
        : state.form.ManualInventoryChangeBranchIds;


    let actionOptions = [
        { text: "All", value: "0" },
        { text: "Increase", value: "1" },
        { text: "Decrease", value: "2" },
    ]
    let reasonOptions = [
        { text: "All", value: "0" },
        { text: "Destroyed/Damaged", value: "1" },
        { text: "Lost/Theft", value: "2" },
        { text: "Returned to Distributor", value: "3" },
        { text: "Transfer between Branches", value: "4" },
        { text: "Other", value: "6" },
    ]

    let isCannabis = [
        {
            text: "All", value: "2"
        },
        {
            text: "Cannabis", value: "1"
        },
        {
            text: "Non-Cannabis", value: "0"
        }
    ];

    if (state.common.applicationSettings.isMedical) {
        reasonOptions.push({ text: "Bulk to Unit", value: "5" });
    }

    return {
        brachOptions: brachOptions,
        isCannabisOptions: isCannabis,
        category: state.entity.productCategories,
        categoryFilter: state.form.ManualInventoryChangeCategoryOption,
        isCannabis: state.form.ManualInventoryChangeIsCannabis,
        manualInventoryChange: state.reports.manualInventoryChange,
        loggedBranch: state.common.branchId,
        beginDate: state.form.ManualInventoryChangeBeginDate,
        endDate: state.form.ManualInventoryChangeEndDate,
        branchIds: branchIds,
        actionOptions: actionOptions,
        reasonOptions: reasonOptions,
        filterAction: state.form.ManualInventoryChangeFilterAction,
        filterReason: state.form.ManualInventoryChangeFilterReason
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getManualInventoryChange: model => dispatch(getManualInventoryChange(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        resetProductCategories: () => dispatch(resetProductCategories()),
        getProductCategories: (branchId) => dispatch(getProductCategories(branchId)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ManualInventoryChange));